/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetTaskResponse,
  Result,
} from '../models/index';
import {
    GetTaskResponseFromJSON,
    GetTaskResponseToJSON,
    ResultFromJSON,
    ResultToJSON,
} from '../models/index';

export interface ApiTasksGetRequest {
    xTenantID?: number;
}

export interface ApiTasksIdGetRequest {
    id: string;
    xTenantID?: number;
}

export interface ApiTasksPostRequest {
    xTenantID?: number;
    entityName?: string;
    actionName?: string;
    payload?: string;
    files?: Array<Blob>;
}

/**
 * 
 */
export class TasksApi extends runtime.BaseAPI {

    /**
     * Retrieve a list of the most recently executed tasks. It will return up to 10 tasks, ordered by execution time in descending order.Returning personalized tasks for the user
     * Get recent tasks
     */
    async apiTasksGetRaw(requestParameters: ApiTasksGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetTaskResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tasks`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetTaskResponseFromJSON));
    }

    /**
     * Retrieve a list of the most recently executed tasks. It will return up to 10 tasks, ordered by execution time in descending order.Returning personalized tasks for the user
     * Get recent tasks
     */
    async apiTasksGet(requestParameters: ApiTasksGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetTaskResponse>> {
        const response = await this.apiTasksGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve task details using the associated WorkItem ID.
     * Get task by WorkItem ID
     */
    async apiTasksIdGetRaw(requestParameters: ApiTasksIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTaskResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTasksIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tasks/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTaskResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve task details using the associated WorkItem ID.
     * Get task by WorkItem ID
     */
    async apiTasksIdGet(requestParameters: ApiTasksIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTaskResponse> {
        const response = await this.apiTasksIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new task by providing the necessary details in the request body. Include either search criteria or selected ids.
     * Create task
     */
    async apiTasksPostRaw(requestParameters: ApiTasksPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['entityName'] != null) {
            formParams.append('EntityName', requestParameters['entityName'] as any);
        }

        if (requestParameters['actionName'] != null) {
            formParams.append('ActionName', requestParameters['actionName'] as any);
        }

        if (requestParameters['payload'] != null) {
            formParams.append('Payload', requestParameters['payload'] as any);
        }

        if (requestParameters['files'] != null) {
            requestParameters['files'].forEach((element) => {
                formParams.append('Files', element as any);
            })
        }


        let urlPath = `/api/tasks`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a new task by providing the necessary details in the request body. Include either search criteria or selected ids.
     * Create task
     */
    async apiTasksPost(requestParameters: ApiTasksPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTasksPostRaw(requestParameters, initOverrides);
    }

}
